import { render, staticRenderFns } from "./MarginUnderThreshold.vue?vue&type=template&id=7724aa86&scoped=true"
import script from "./MarginUnderThreshold.vue?vue&type=script&lang=js"
export * from "./MarginUnderThreshold.vue?vue&type=script&lang=js"
import style0 from "./MarginUnderThreshold.vue?vue&type=style&index=0&id=7724aa86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7724aa86",
  null
  
)

export default component.exports